// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
const firebaseConfig = {
  apiKey: "AIzaSyAEnlbl76bWSyhNPmPkfoXToB9kY4ADZPs",
  authDomain: "auto-a60e4.firebaseapp.com",
  projectId: "auto-a60e4",
  storageBucket: "auto-a60e4.firebasestorage.app",
  messagingSenderId: "74186188333",
  appId: "1:74186188333:web:319f812daf4eb409ae7aa4",
  measurementId: "G-4MK4HY9JQM"
};

// Initialisation
const app = initializeApp(firebaseConfig);

const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

export { db, auth, storage };